import { TagMuted } from '@components/core-ui/Tag/variations/TagMuted';

type TeamTagProps = {
  team: { name: string; slug?: string; colour?: string };
  active?: boolean;
  onClick: () => any;
  customStyle?: Record<string, string>;
};

export default function TeamTag({ team, active = true, onClick, customStyle = {} }: TeamTagProps) {
  const textColor = team.colour ? 'var(--color-surface)' : 'var(--color-text)';
  return (
    <TagMuted
      style={{
        backgroundColor: team.colour || undefined,
        opacity: active ? '1' : '0.3',
        color: textColor,
        ...customStyle,
      }}
      className="mr-2 px-2 py-1 rounded-xl text-sm flex-shrink-0"
      onClick={onClick}
    >
      {team.name || team.slug}
    </TagMuted>
  );
}
